import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportTrelloRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-trello',
	path: '/secure/admin/Trello(\\w+)Page([!%]?[\\w]*).jspa',
};
